import React from 'react';
import { CheckBoxWrapper, CheckBox, CheckBoxLabel } from './styles';
var SwitchButton = function (_a) {
    var isChecked = _a.isChecked, onChange = _a.onChange, isDisabled = _a.isDisabled;
    return (React.createElement(CheckBoxWrapper, null,
        React.createElement(CheckBox, { checked: isDisabled ? false : isChecked, onClick: onChange, id: "checkbox", type: "checkbox", disabled: isDisabled }),
        React.createElement(CheckBoxLabel, { htmlFor: "checkbox" })));
};
export default SwitchButton;
